import React from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const SingleLink = ({ link, setShow }) => {
  const go = (e) => {
    if (location.pathname === link.to) e.preventDefault();
    setShow(false);
  };

  return (
    <NavLink
      end
      key={link.to}
      to={link.to}
      onClick={go}
      className="nav-link rounded"
    >
      <Row>
        <Col
          xs={3}
          className="d-flex justify-content-center align-items-center"
        >
          <link.Icon size={25} />
        </Col>
        <Col xs={9}>
          <span className="m-0">{link.text}</span>
        </Col>
      </Row>
    </NavLink>
  );
};

export default SingleLink;
